import { useCheckInTicketMutation } from "@garther/query-hooks";
import { getErrorMessage, toast, useI18n } from "@garther/ui/libs";

export { ticketsKeys, useTicket, useTicketsInvalidation } from "@garther/query-hooks";

export function useCheckInTicket() {
  const { t } = useI18n();
  return useCheckInTicketMutation({
    onError: (error) => toast.error(getErrorMessage(error) || t("common.error.tryAgain"))
  });
}
